import IEdgeData from "./interfaces/IEdgeData";

class Edges {

  private mPath: string;
  private mEdges: { [id: string]: IEdgeData };

  public constructor(path: string) {
    this.mPath = path;
    this.mEdges = {};
  }

  public request(): Promise<string | void> {
    return fetch(this.mPath)
      .then((response: Response) => response.json())
      .then((json: IEdgeData[]) => {
        this.mEdges = {};

        for (let child of json) {
          // Use the first override name if it exists
          if (child.OverrideNames != null) {
            if (child.OverrideNames.length > 0) {
              child.Name = child.OverrideNames[0];
            }
          }

          this.mEdges[child.ID] = child;
        }

        return new Promise<string>(
          (resolve, reject) => {
            resolve("Fetching Edges ready!");
            reject("Fetching Edges failed!");
          }
        );
      })
      .catch((error: any) => {
        console.error("Error loading JSON:", error);
      });
  }

  public findByID(id: string): IEdgeData | null {
    const child = this.mEdges[id];
    return (child ? child : null);
  }

  public first(): IEdgeData | null {
    const first = this.mEdges[Object.keys(this.mEdges)[0]];
    return (first ? first : null);
  }

  public children(): IEdgeData[] {
    return Object.values(this.mEdges);
  }
}

export default Edges;
